import { useState } from "react";
import Footer from "./components/Footer";
import Headers from "./components/Header";
import Meals from "./components/Meals";
import Modal from "./components/Modal";
import "./styles.css";

function App() {
  const [call, setCall] = useState(false);
  const showNumber = (event) => {
    event.preventDefault();
    setCall(true);
    return;
  };
  const callHandler = () => {
    setCall(false);
  };
  return (
    <div className="App">
      <Headers onShowNumber={showNumber} />
      {call && <Modal buttonClicked={callHandler} />}
      <Meals />
      <Footer />
    </div>
  );
}

export default App;
